export default "__VITE_PUBLIC_ASSET__3ac343df__"